import { createContext } from 'react'
import { AlertType } from '../../content/TNToastNotification/TNToastNotification.routing'
import { ToastType } from '../components/TNSlideToast'
import { ScreenType } from './useScreen'

export interface MessageBanner {
    text: string
    type: AlertType
}
export interface ToastMessage {
    text: string
    type: ToastType
    show: boolean
}
export interface IMyAccountContext {
    screen: ScreenType
    setScreen: React.Dispatch<React.SetStateAction<ScreenType>>
    isScreenSelected: boolean
    setScreenSelected: React.Dispatch<React.SetStateAction<boolean>>
    messageBanner?: MessageBanner
    setMessageBanner: React.Dispatch<
        React.SetStateAction<MessageBanner | undefined>
    >
    toast: ToastMessage
    setToast: React.Dispatch<React.SetStateAction<ToastMessage>>
    goBackToParent: (clearMessageBanner: boolean) => void
}

export const MyAccountContext = createContext<IMyAccountContext>({
    screen: 'manage-account',
    setScreen: (): void => {},
    isScreenSelected: true,
    setScreenSelected: () => {},
    setMessageBanner: () => {},
    toast: {
        type: 'success',
        text: '',
        show: false,
    },
    setToast: () => {},
    goBackToParent: () => {},
})
